import { render, staticRenderFns } from "./RecoverPass.vue?vue&type=template&id=da477f88&scoped=true"
import script from "./RecoverPass.vue?vue&type=script&lang=js"
export * from "./RecoverPass.vue?vue&type=script&lang=js"
import style0 from "./RecoverPass.vue?vue&type=style&index=0&id=da477f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da477f88",
  null
  
)

export default component.exports